export const logoPrefix = "/logos";
export const landingPrefix = "/landing";
export const logoURL = {
  logo1: logoPrefix + "/USGS_logo",
  logo2: logoPrefix + "/USACE_logo",
  logo3: logoPrefix + "/asu_university_logo",
  mekong: logoPrefix + "/Mekong_US_Partnership_type_logo_white.png",
  mrc: "/logos/MRC_logo.png",
  map: logoPrefix + "/mekong_river_map_transparency.png",
};

export const bgImages = [
  "/Cambodia.jpg",
  "/Laos.jpg",
  "/Thailand.jpg",
  "/Vietnam.jpg",
];
